export default __webpack_public_path__ + "static/media/noPosterSmall.152320d4.PNG";